import LayoutContentWrp from './LayoutContentWrp';
import { LAYOUT_CONTENT_WRP_ID } from './constants';

export default LayoutContentWrp;
export { LAYOUT_CONTENT_WRP_ID };
